import { HHTabs } from '@hinge-health/react-component-library';
import { useROIRoleBasedRoutes } from '../../hooks/use-roi-role-based-routes';
import { AssessmentTasksTab } from '../assessment-tasks/components/assessment-tasks-tab';
import {
  tabLabels,
  tabRoutes,
} from '../constants/hinge-connect-constants.constant';
import { HealthRecordsTab } from '../health-records/components/health-records-tab';
import { RuleAssessmentsTab } from '../rule-assessments/components/rule-assessments-tab';
import { RulesTab } from '../rules/components/rules-tab';
import { TagsTab } from '../tags/components/tags-tab';
import { UserTagsTab } from '../user-tags/components/user-tags-tab';

export const HingeConnectTabs = (): JSX.Element => {
  const routeAccess = useROIRoleBasedRoutes();

  const tabs = [];

  // Add tabs based on role permissions
  if (routeAccess.hingeConnectRules) {
    tabs.push({
      tabLabel: tabLabels.rules,
      tabContent: <RulesTab />,
      to: `/${tabRoutes.baseRoute}/${tabRoutes.rules}`,
    });
  }

  if (routeAccess.hingeConnectTags) {
    tabs.push({
      tabLabel: tabLabels.tags,
      tabContent: <TagsTab />,
      to: `/${tabRoutes.baseRoute}/${tabRoutes.tags}`,
    });
  }

  if (routeAccess.hingeConnectAssessmentTasks) {
    tabs.push({
      tabLabel: tabLabels.assessmentTasks,
      tabContent: <AssessmentTasksTab />,
      to: `/${tabRoutes.baseRoute}/${tabRoutes.assessmentTasks}`,
    });
  }

  if (routeAccess.hingeConnectRuleAssessments) {
    tabs.push({
      tabLabel: tabLabels.ruleAssessments,
      tabContent: <RuleAssessmentsTab />,
      to: `/${tabRoutes.baseRoute}/${tabRoutes.ruleAssessments}`,
    });
  }

  // PHI tabs - permission already includes PHI access check from the hook
  if (routeAccess.hingeConnectHealthRecords) {
    tabs.push({
      tabLabel: tabLabels.healthRecords,
      tabContent: <HealthRecordsTab />,
      to: `/${tabRoutes.baseRoute}/${tabRoutes.healthRecords}`,
    });
  }

  if (routeAccess.hingeConnectUserTags) {
    tabs.push({
      tabLabel: tabLabels.userTags,
      tabContent: <UserTagsTab />,
      to: `/${tabRoutes.baseRoute}/${tabRoutes.userTags}`,
    });
  }

  const tabsData = tabs;

  return <HHTabs variant="fullWidth" centered={false} {...{ tabsData }} />;
};
